import React from "react";

import MainLayout from "components/MainLayout";
import MainList from "components/MainList";

import columns from "./columns";
import CreateClientModal from "components/create_modals/CreateClientModal";
import { useAuth } from "context/providers/auth";

const ClientsList = () => {
  const {
    state: {
      user: { clients_index_columns },
    },
    updateUserClientIndexColumns,
  } = useAuth();
  return (
    <MainLayout
      breadcrumbs={[{ name: "Klienci" }]}
      buttons={<CreateClientModal />}
    >
      <MainList
        columns={columns}
        query_name="clients"
        query_path="/clients"
        table_path="/clients"
        query_context="index"
        show_checklist={true}
        checked_list={clients_index_columns}
        updateCheckedList={updateUserClientIndexColumns}
      />
    </MainLayout>
  );
};
export default ClientsList;
